import React, { useState, useEffect } from 'react';
import { useStock } from '../contexts/StockContext';
import SerialDetailsModal from './SerialDetailsModal.jsx';

// ข้อมูลชาร์จเจอร์จะถูกโหลดผ่าน useChargerStock hook จาก MySQL API



const ChargerStockList = ({ currentUser, onNavigate }) => {
  const {
    chargerStock: data,
    loading,
    error,
    updateChargerStock,
    deleteChargerStock,
    fetchChargerStock
  } = useStock();

  // ฟังก์ชันแปลงข้อมูลภาษาอังกฤษเป็นภาษาไทยสำหรับการแสดงผล
  const translateToThai = (value, type) => {
    if (!value) return value;

    const translations = {
      type: {
        'onboard': 'ออนบอร์ด',
        'offboard': 'ออฟบอร์ด'
      },
      status: {
        'available': 'พร้อมขาย',
        'sold': 'ขายแล้ว',
        'reserved': 'ติดจอง',
        'repair': 'ซ่อมแซม'
      },
      condition: {
        'new': 'ใหม่',
        'used': 'มือสอง',
        'repair': 'ซ่อมแซม'
      }
    };

    return translations[type]?.[value] || value;
  };

  const [filters, setFilters] = useState({
    status: 'all',
    brand: '',
    search: '',
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20); // แสดง 20 รายการต่อหน้า
  const [editingItem, setEditingItem] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showReserveModal, setShowReserveModal] = useState(false);
  const [reservingItem, setReservingItem] = useState(null);
  const [reserverName, setReserverName] = useState('');
  const [showSerialModal, setShowSerialModal] = useState(false);
  const [selectedSerialItem, setSelectedSerialItem] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelTargetItem, setCancelTargetItem] = useState(null);
  const [cancelPermissionMessage, setCancelPermissionMessage] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // ข้อมูลจะถูกจัดการผ่าน Database Service โดยอัตโนมัติ

  // โหลดข้อมูลเมื่อ component mount
  useEffect(() => {
    fetchChargerStock();
  }, [fetchChargerStock]);

  // โหลดข้อมูลเมื่อ data เปลี่ยนแปลง (เช่น เมื่อมีการเพิ่มข้อมูลใหม่)
  useEffect(() => {
    // ไม่ต้องทำอะไร เพราะ context จะอัปเดตอัตโนมัติ
  }, [data]);

  // รีเฟรชข้อมูลเมื่อหน้าต่างได้รับ focus เท่านั้น
  useEffect(() => {
    const handleFocus = () => {
      fetchChargerStock();
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [fetchChargerStock]);

  // รีเซ็ตหน้าเมื่อมีการกรองข้อมูล
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  // ตรวจสอบว่าผู้ใช้มีสิทธิ์แก้ไข/ลบหรือไม่
  const canEditDelete = currentUser && (currentUser.role === 'admin' || currentUser.role === 'stock');

  // ฟังก์ชันคำนวณอายุสินค้า (ใช้วันที่แบบ local เพื่อเลี่ยง off-by-one)
  const calculateAge = (receivedDate) => {
    if (!receivedDate) return '-';

    const s = String(receivedDate).trim();
    let y, m, d;

    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [yy, mm, dd] = s.split('-');
      y = Number(yy); m = Number(mm); d = Number(dd);
    } else if (s.includes('T')) {
      const datePart = s.split('T')[0];
      const parts = datePart.split('-');
      if (parts.length === 3) {
        y = Number(parts[0]); m = Number(parts[1]); d = Number(parts[2]);
      }
    }

    if (y === undefined) {
      const dm = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
      if (dm) {
        d = Number(dm[1]);
        m = Number(dm[2]);
        y = Number(dm[3]);
      }
    }

    if (y === undefined) {
      const dt = new Date(s);
      if (isNaN(dt)) return '-';
      y = dt.getFullYear();
      m = dt.getMonth() + 1;
      d = dt.getDate();
    }

    const receivedLocal = new Date(y, m - 1, d);
    const now = new Date();
    const todayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffDays = Math.floor((todayLocal - receivedLocal) / 86400000);
    const safeDays = diffDays < 0 ? 0 : diffDays;

    if (safeDays < 30) {
      return `${safeDays} วัน`;
    } else if (safeDays < 365) {
      const months = Math.floor(safeDays / 30);
      return `${months} เดือน`;
    } else {
      const years = Math.floor(safeDays / 365);
      const remainingMonths = Math.floor((safeDays % 365) / 30);
      return remainingMonths > 0 ? `${years} ปี ${remainingMonths} เดือน` : `${years} ปี`;
    }
  };

  // ฟังก์ชันส่งออกข้อมูลเป็น CSV
  const exportToCSV = () => {
    // กรองข้อมูลตาม filters ปัจจุบัน
    const filteredData = (data || []).filter((item) => {
      const matchesStatus = filters.status === 'all' || item.status === filters.status;
      const matchesBrand = !filters.brand || item.brand.toLowerCase().includes(filters.brand.toLowerCase());
      const matchesSearch = !filters.search ||
        item.serial.toLowerCase().includes(filters.search.toLowerCase()) ||
        item.brand.toLowerCase().includes(filters.search.toLowerCase()) ||
        item.capacity.toString().includes(filters.search) ||
        item.bmsOrType.toLowerCase().includes(filters.search.toLowerCase()) ||
        item.note.toLowerCase().includes(filters.search.toLowerCase());

      return matchesStatus && matchesBrand && matchesSearch;
    });

    // สร้าง CSV header
    const headers = [
      'ซีเรียล',
      'ยี่ห้อ',
      'ความจุ (A)',
      'ประเภท/BMS',
      'สภาพสินค้า',
      'สถานะ',
      'อายุสินค้า',
      'วันรับเข้า',
      'หมายเหตุ',
      'ผู้จอง'
    ];

    // สร้าง CSV content
    const formatDateSafe = (d) => {
      if (!d) return '';
      const s = String(d);
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
      if (s.includes('T')) {
        const datePart = s.split('T')[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
      }
      try {
        const dt = new Date(s);
        if (isNaN(dt)) return s;
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const da = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${da}`;
      } catch {
        return s;
      }
    };
    const csvContent = [
      headers.join(','),
      ...filteredData.map(item => [
        `"${item.serial}"`,
        `"${item.brand}"`,
        item.capacity,
        `"${item.bmsOrType}"`,
        `"${item.condition === 'new' ? 'ใหม่' : 'มือสอง'}"`,
        `"${item.status}"`,
        `"${calculateAge(item.receivedDate)}"`,
        `"${formatDateSafe(item.entryDate)}"`,
        `"${item.note || ''}"`,
        `"${item.reserver || ''}"`
      ].join(','))
    ].join('\n');

    // สร้างไฟล์และดาวน์โหลด
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `charger-stock-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ฟังก์ชันแก้ไขข้อมูล
  const handleEdit = (item) => {
    // Normalize date fields to input-friendly YYYY-MM-DD to avoid browser/locale quirks
    const normalizeDateForInput = (d) => {
      if (!d) return '';
      const s = String(d);
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s; // already YYYY-MM-DD
      if (s.includes('T')) {
        const datePart = s.split('T')[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
      }
      const dm = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
      if (dm) {
        const dd = dm[1].padStart(2, '0');
        const mm = dm[2].padStart(2, '0');
        const yyyy = dm[3];
        return `${yyyy}-${mm}-${dd}`;
      }
      const num = Number(s);
      if (!isNaN(num) && num > 25569 && num < 60000) {
        const base = new Date(1899, 11, 30);
        const dt = new Date(base.getTime() + num * 86400000);
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const da = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${da}`;
      }
      try {
        const dt = new Date(s);
        if (isNaN(dt)) return '';
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const da = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${da}`;
      } catch {
        return '';
      }
    };

    const normalizedItem = {
      ...item,
      receivedDate: normalizeDateForInput(item.receivedDate),
      entryDate: normalizeDateForInput(item.entryDate)
    };
    setEditingItem(normalizedItem);
    setShowEditModal(true);
  };

  // ฟังก์ชันลบข้อมูล
  const handleDelete = async (id) => {
    if (window.confirm('คุณต้องการลบรายการนี้หรือไม่?')) {
      try {
        await deleteChargerStock(id);
        // ข้อมูลจะอัปเดตอัตโนมัติผ่าน hook
      } catch (error) {
        alert('เกิดข้อผิดพลาดในการลบข้อมูล: ' + error.message);
      }
    }
  };

  // ฟังก์ชันบันทึกการแก้ไข
  const handleSaveEdit = async () => {
    try {
      await updateChargerStock(editingItem.id, editingItem);
      setShowEditModal(false);
      setEditingItem(null);
      // ข้อมูลจะอัปเดตอัตโนมัติผ่าน hook
    } catch (error) {
      alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message);
    }
  };

  // ฟังก์ชันยกเลิกการแก้ไข
  const handleCancelEdit = () => {
    setShowEditModal(false);
    setEditingItem(null);
  };

  // ฟังก์ชันจองสินค้า
  const handleReserve = (item) => {
    setReservingItem(item);
    setReserverName(currentUser ? currentUser.name : '');
    setShowReserveModal(true);
  };

  // ฟังก์ชันบันทึกการจอง
  const handleSaveReservation = async () => {
    if (!reserverName.trim()) {
      alert('กรุณาใส่ชื่อผู้จอง');
      return;
    }

    try {
      const updatedItem = {
        ...reservingItem,
        status: 'ติดจอง',
        reserver: reserverName
      };
      await updateChargerStock(reservingItem.id, updatedItem);
      alert(`จองชาร์จเจอร์ ${reservingItem.serial} สำเร็จแล้ว`);
      setShowReserveModal(false);
      setReservingItem(null);
      setReserverName('');
      // รีเฟรชข้อมูลด้วย filters ปัจจุบัน
      fetchChargerStock(filters);
    } catch (error) {
      alert('เกิดข้อผิดพลาดในการจองสินค้า: ' + error.message);
    }
  };

  // ฟังก์ชันยกเลิกการจอง (ปิด modal)
  const handleCancelReservation = () => {
    setShowReserveModal(false);
    setReservingItem(null);
    setReserverName('');
  };

  // เปิดโมดอลยืนยันการยกเลิก พร้อมตรวจสอบสิทธิ์
  const openCancelReservationModal = (item) => {
    setCancelTargetItem(item);
    const isAdmin = currentUser && currentUser.role === 'admin';
    const reserver = (item.reserver || '').trim();
    const isOwner = currentUser && reserver && currentUser.name === reserver;
    if (!isAdmin && !isOwner) {
      setCancelPermissionMessage('คุณไม่มีสิทธิ์ในการยกเลิกการจองนี้ (ต้องเป็นผู้จองหรือผู้ดูแลระบบ)');
    } else {
      setCancelPermissionMessage('');
    }
    setShowCancelModal(true);
  };

  // ยืนยันการยกเลิกด้วยสิทธิ์ที่ถูกต้อง และบันทึกประวัติลงหมายเหตุ
  const handleCancelReservationConfirm = async () => {
    if (!cancelTargetItem) return;
    const isAdmin = currentUser && currentUser.role === 'admin';
    const reserver = (cancelTargetItem.reserver || '').trim();
    const isOwner = currentUser && reserver && currentUser.name === reserver;
    if (!isAdmin && !isOwner) {
      alert('ปฏิเสธการดำเนินการ: คุณไม่มีสิทธิ์ยกเลิกการจองนี้');
      return;
    }
    try {
      const operator = `${currentUser?.name || 'Unknown'} (${currentUser?.role || 'user'})`;
      const timestamp = new Date().toLocaleString('th-TH');
      const logEntry = `ยกเลิกจองโดย ${operator} วันที่ ${timestamp}`;
      const updatedItem = {
        ...cancelTargetItem,
        status: 'พร้อมขาย',
        reserver: '',
        note: [cancelTargetItem.note?.trim(), logEntry].filter(Boolean).join(' | ')
      };
      await updateChargerStock(cancelTargetItem.id, updatedItem);
      alert(`ยกเลิกการจองชาร์จเจอร์ ${cancelTargetItem.serial} สำเร็จแล้ว`);
      setShowCancelModal(false);
      setCancelTargetItem(null);
      fetchChargerStock(filters);
    } catch (error) {
      alert('เกิดข้อผิดพลาดในการยกเลิกการจอง: ' + error.message);
    }
  };

  // เปิด/ปิด Serial Details Modal
  const handleOpenSerialModal = (item) => {
    setSelectedSerialItem(item);
    setShowSerialModal(true);
  };

  const handleCloseSerialModal = () => {
    setShowSerialModal(false);
    setSelectedSerialItem(null);
  };

  // ฟังก์ชันจัดการการเปลี่ยนแปลงข้อมูลในฟอร์มแก้ไข
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditingItem(prev => ({
      ...prev,
      [name]: value
    }));
  };



  // แสดง loading state
  if (loading) {
    return (
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  // แสดง error state
  if (error) {
    return (
      <div className="container-fluid mt-4">
        <div className="alert alert-danger" role="alert">
          เกิดข้อผิดพลาด: {error}
        </div>
      </div>
    );
  }

  // กรองข้อมูลชาร์จเจอร์
  const filteredData = data.filter((item) => {
    const matchesStatus = filters.status === 'all' || item.status === filters.status;
    const matchesBrand = !filters.brand || item.brand.toLowerCase().includes(filters.brand.toLowerCase());
    const matchesSearch = !filters.search ||
      item.serial.toLowerCase().includes(filters.search.toLowerCase()) ||
      item.brand.toLowerCase().includes(filters.search.toLowerCase()) ||
      item.capacity.toString().includes(filters.search) ||
      item.bmsOrType.toLowerCase().includes(filters.search.toLowerCase()) ||
      item.note.toLowerCase().includes(filters.search.toLowerCase());

    return matchesStatus && matchesBrand && matchesSearch;
  });

  // เรียงลำดับข้อมูล
  if (sortConfig.key) {
    filteredData.sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // กรณีเรียงตามอายุสินค้า
      if (sortConfig.key === 'age') {
        // แปลงอายุเป็นจำนวนวันเพื่อเปรียบเทียบ
        const getDays = (date) => {
          if (!date) return -1;
          const ageStr = calculateAge(date);
          if (ageStr === '-') return -1;

          if (ageStr.includes('วัน')) return parseInt(ageStr);
          if (ageStr.includes('เดือน')) {
            const parts = ageStr.split(' ');
            if (parts.length > 2) { // ปี และ เดือน
              return (parseInt(parts[0]) * 365) + (parseInt(parts[2]) * 30);
            }
            return parseInt(parts[0]) * 30;
          }
          if (ageStr.includes('ปี')) {
            const parts = ageStr.split(' ');
            if (parts.length > 2) { // ปี และ เดือน
              return (parseInt(parts[0]) * 365) + (parseInt(parts[2]) * 30);
            }
            return parseInt(parts[0]) * 365;
          }
          return 0;
        };
        aValue = getDays(a.receivedDate);
        bValue = getDays(b.receivedDate);
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }

  // คำนวณ pagination
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0 thai-text">
          <i className="fas fa-plug me-2"></i>
          สต๊อกชาร์จเจอร์
          <span className="badge bg-primary ms-2">{(data || []).length}</span>

        </h2>
        <div>
          <button
            className="btn btn-primary me-2"
            onClick={() => onNavigate && onNavigate('addProduct')}
            title="เพิ่มสินค้าใหม่"
          >
            <i className="fas fa-plus me-2"></i>
            เพิ่มสินค้า
          </button>
          <button
            className="btn btn-success"
            onClick={exportToCSV}
            title="ส่งออกข้อมูลเป็น CSV"
          >
            <i className="fas fa-download me-2"></i>
            ส่งออกข้อมูล
          </button>
        </div>
      </div>

      {/* ตัวกรองสำหรับชาร์จเจอร์ */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label className="form-label thai-text">สถานะ:</label>
          <select
            className="form-select"
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
          >
            <option value="all">ทั้งหมด</option>
            <option value="พร้อมขาย">พร้อมขาย</option>
            <option value="ติดจอง">ติดจอง</option>
            <option value="ขายแล้ว">ขายแล้ว</option>
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label thai-text">ยี่ห้อ:</label>
          <input
            type="text"
            className="form-control"
            name="brand"
            value={filters.brand}
            onChange={handleFilterChange}
            placeholder="ค้นหาตามยี่ห้อ"
          />
        </div>
        <div className="col-md-6">
          <label className="form-label thai-text">ค้นหา:</label>
          <input
            type="text"
            className="form-control"
            name="search"
            value={filters.search}
            onChange={handleFilterChange}
            placeholder="ค้นหาตามซีเรียล, ยี่ห้อ, ความจุ, ประเภท, หมายเหตุ"
          />
        </div>
      </div>

      {/* ตารางชาร์จเจอร์ (ย่อคอลัมน์ให้กะทัดรัด) */}
      <div className="table-responsive">
        <table className="table table-striped table-hover table-sm" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={{ whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={() => handleSort('serial')}>
                ซีเรียล {sortConfig.key === 'serial' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th style={{ whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={() => handleSort('brand')}>
                ยี่ห้อ {sortConfig.key === 'brand' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th className="text-center" style={{ whiteSpace: 'nowrap', width: '100px', cursor: 'pointer' }} onClick={() => handleSort('capacity')}>
                กระแสชาร์จ (A) {sortConfig.key === 'capacity' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th className="text-center" style={{ whiteSpace: 'nowrap', width: '100px', cursor: 'pointer' }} onClick={() => handleSort('condition')}>
                สภาพ {sortConfig.key === 'condition' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th className="text-center" style={{ whiteSpace: 'nowrap', width: '120px', cursor: 'pointer' }} onClick={() => handleSort('receivedDate')}>
                วันรับเข้า {sortConfig.key === 'receivedDate' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th className="text-center" style={{ whiteSpace: 'nowrap', width: '120px', cursor: 'pointer' }} onClick={() => handleSort('age')}>
                อายุสินค้า {sortConfig.key === 'age' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th className="text-center" style={{ whiteSpace: 'nowrap', width: '120px', cursor: 'pointer' }} onClick={() => handleSort('status')}>
                สถานะ {sortConfig.key === 'status' && (sortConfig.direction === 'ascending' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>)}
              </th>
              <th className="text-center" style={{ whiteSpace: 'nowrap', width: '140px' }}>จัดการ</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((item) => (
                <tr key={item.id}>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button
                      className="btn btn-link p-0 thai-text serial-link"
                      title="ดูรายละเอียดซีเรียล"
                      onClick={() => handleOpenSerialModal(item)}
                      style={{ textDecoration: 'underline' }}
                    >
                      {item.serial}
                    </button>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{item.brand}</td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{item.capacity}</td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    <span className={`badge ${item.condition === 'new' || item.condition === 'ใหม่' ? 'bg-info text-dark' : 'bg-secondary'
                      }`}>
                      {translateToThai(item.condition, 'condition')}
                    </span>
                  </td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    {item.receivedDate ? new Date(item.receivedDate).toLocaleDateString('th-TH') : '-'}
                  </td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    {calculateAge(item.receivedDate)}
                  </td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    <span className={`badge ${item.status === 'available' || item.status === 'พร้อมขาย' ? 'bg-success' :
                      item.status === 'reserved' || item.status === 'ติดจอง' ? 'bg-warning' :
                        'bg-secondary'
                      }`}>
                      {translateToThai(item.status, 'status')}
                    </span>
                  </td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    {(item.status === 'available' || item.status === 'พร้อมขาย') && (
                      <button
                        className="btn btn-sm btn-outline-warning me-1"
                        onClick={() => handleReserve(item)}
                        title="จอง"
                      >
                        <i className="fas fa-bookmark"></i>
                      </button>
                    )}
                    {(item.status === 'reserved' || item.status === 'ติดจอง') && (
                      <button
                        className="btn btn-sm btn-outline-secondary me-1"
                        onClick={() => openCancelReservationModal(item)}
                        title="ยกเลิกจอง"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}
                    {canEditDelete && (
                      <>
                        <button
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => handleEdit(item)}
                          title="แก้ไข"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(item.id)}
                          title="ลบ"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center thai-text">ไม่พบข้อมูล</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Serial Details Modal */}
      {
        showSerialModal && selectedSerialItem && (
          <SerialDetailsModal
            isOpen={showSerialModal}
            onClose={handleCloseSerialModal}
            item={selectedSerialItem}
            type="charger"
          />
        )
      }

      {/* Pagination Controls */}
      {
        totalPages > 1 && (
          <nav aria-label="Page navigation" className="mt-3">
            <ul className="pagination justify-content-center">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ก่อนหน้า
                </button>
              </li>

              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                const isCurrentPage = pageNumber === currentPage;
                const showPage =
                  pageNumber === 1 ||
                  pageNumber === totalPages ||
                  (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2);

                if (!showPage) {
                  if (pageNumber === currentPage - 3 || pageNumber === currentPage + 3) {
                    return (
                      <li key={pageNumber} className="page-item disabled">
                        <span className="page-link">...</span>
                      </li>
                    );
                  }
                  return null;
                }

                return (
                  <li key={pageNumber} className={`page-item ${isCurrentPage ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}

              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  ถัดไป
                </button>
              </li>
            </ul>
          </nav>
        )
      }

      <div className="mt-3">
        <p className="thai-text">
          แสดง {startIndex + 1}-{Math.min(endIndex, totalItems)} จาก {totalItems} รายการ
          {totalPages > 1 && ` (หน้า ${currentPage} จาก ${totalPages})`}
        </p>
      </div>

      {/* Modal สำหรับแก้ไขข้อมูล */}
      {
        showEditModal && editingItem && (
          <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title thai-text">แก้ไขข้อมูลชาร์จเจอร์</h5>
                  <button type="button" className="btn-close" onClick={handleCancelEdit}></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">ซีเรียล:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="serial"
                        value={editingItem.serial}
                        onChange={handleEditInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">ยี่ห้อ:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="brand"
                        value={editingItem.brand}
                        onChange={handleEditInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">ความจุ (A):</label>
                      <input
                        type="number"
                        className="form-control"
                        name="capacity"
                        value={editingItem.capacity}
                        onChange={handleEditInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">ประเภท:</label>
                      <select
                        className="form-select"
                        name="bmsOrType"
                        value={editingItem.bmsOrType}
                        onChange={handleEditInputChange}
                      >
                        <option value="on board">on board</option>
                        <option value="off board">off board</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">สภาพสินค้า:</label>
                      <select
                        className="form-select"
                        name="condition"
                        value={editingItem.condition}
                        onChange={handleEditInputChange}
                      >
                        <option value="new">ใหม่</option>
                        <option value="used">มือสอง</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">สถานะ:</label>
                      <select
                        className="form-select"
                        name="status"
                        value={editingItem.status}
                        onChange={handleEditInputChange}
                      >
                        <option value="พร้อมขาย">พร้อมขาย</option>
                        <option value="ติดจอง">ติดจอง</option>
                        <option value="ขายแล้ว">ขายแล้ว</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">ผู้จอง:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="reserver"
                        value={editingItem.reserver}
                        onChange={handleEditInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">วันรับเข้า:</label>
                      <input
                        type="date"
                        className="form-control"
                        name="receivedDate"
                        value={editingItem.receivedDate}
                        onChange={handleEditInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label thai-text">วันบันทึก:</label>
                      <input
                        type="date"
                        className="form-control"
                        name="entryDate"
                        value={editingItem.entryDate}
                        onChange={handleEditInputChange}
                      />
                    </div>
                    <div className="col-12 mb-3">
                      <label className="form-label thai-text">หมายเหตุ:</label>
                      <textarea
                        className="form-control"
                        name="note"
                        value={editingItem.note}
                        onChange={handleEditInputChange}
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCancelEdit}>
                    ยกเลิก
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleSaveEdit}>
                    บันทึก
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal สำหรับจองสินค้า */}
      {
        showReserveModal && reservingItem && (
          <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header bg-warning text-dark">
                  <h5 className="modal-title thai-text">
                    <i className="fas fa-bookmark me-2"></i>จองชาร์จเจอร์
                  </h5>
                  <button type="button" className="btn-close" onClick={handleCancelReservation}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label thai-text">ซีเรียลสินค้า:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={reservingItem.serial}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label thai-text">ยี่ห้อ:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={reservingItem.brand}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label thai-text">ความจุ:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={`${reservingItem.capacity} A`}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label thai-text">ผู้จอง:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={reserverName}
                      onChange={(e) => setReserverName(e.target.value)}
                      placeholder="ใส่ชื่อผู้จอง"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCancelReservation}>
                    <i className="fas fa-times me-1"></i>ยกเลิก
                  </button>
                  {reservingItem.status === 'ติดจอง' && (
                    <button
                      type="button"
                      className="btn btn-danger me-2"
                      onClick={() => openCancelReservationModal(reservingItem)}
                    >
                      <i className="fas fa-ban me-1"></i>ยกเลิกการจอง
                    </button>
                  )}
                  <button type="button" className="btn btn-warning" onClick={handleSaveReservation}>
                    <i className="fas fa-bookmark me-1"></i>จองสินค้า
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal ยืนยันการยกเลิกการจอง พร้อมรายละเอียดและสิทธิ์ */}
      {
        showCancelModal && cancelTargetItem && (
          <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header bg-secondary text-white">
                  <h5 className="modal-title thai-text">
                    <i className="fas fa-ban me-2"></i>ยืนยันการยกเลิกการจอง
                  </h5>
                  <button type="button" className="btn-close" onClick={() => setShowCancelModal(false)}></button>
                </div>
                <div className="modal-body">
                  {cancelPermissionMessage && (
                    <div className="alert alert-danger thai-text" role="alert">
                      <i className="fas fa-exclamation-triangle me-2"></i>{cancelPermissionMessage}
                    </div>
                  )}
                  <div className="thai-text">
                    <p className="mb-1"><strong>ซีเรียล:</strong> {cancelTargetItem.serial}</p>
                    <p className="mb-1"><strong>ยี่ห้อ:</strong> {cancelTargetItem.brand}</p>
                    <p className="mb-1"><strong>ความจุ:</strong> {cancelTargetItem.capacity}</p>
                    <p className="mb-1"><strong>สถานะปัจจุบัน:</strong> {translateToThai(cancelTargetItem.status, 'status')}</p>
                    <p className="mb-1"><strong>ผู้จอง:</strong> {cancelTargetItem.reserver || '-'}</p>
                  </div>
                  <div className="alert alert-warning thai-text mt-3">
                    การยกเลิกจะเปลี่ยนสถานะเป็น "พร้อมขาย" และบันทึกชื่อผู้ดำเนินการในหมายเหตุ
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setShowCancelModal(false)}>
                    ปิด
                  </button>
                  <button type="button" className="btn btn-danger" onClick={handleCancelReservationConfirm} disabled={!!cancelPermissionMessage}>
                    ยืนยันยกเลิก
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default ChargerStockList;